import {
  GraphQLRequestError,
  graphQLErrorCode,
  useFetcher,
} from '../../graphql/hooks/useFetcher';

const SAFE_ERROR_CODES = new Set([
  'FORBIDDEN',
  'NOT_FOUND',
  'INVALID_REDIRECT_URI',
  'MISSING_AUTHORIZATION_CODE',
  'INVALID_AUTH_STATE',
  'PROVIDER_NOT_SUPPORTED',
  'OAUTH_EXCHANGE_FAILED',
  'OAUTH_REFRESH_FAILED',
  'OAUTH_INVALID_GRANT',
  'OAUTH_INVALID_CLIENT',
  'OAUTH_RESPONSE_INVALID',
  'OAUTH_AUDIENCE_MISMATCH',
  'INTEGRATION_CONNECTION_BUSY',
  'INTEGRATION_CONNECTION_FAILED',
]);

export const integrationAuthError = (cause?: unknown): GraphQLRequestError => {
  // Axios errors retain request bodies and bearer headers; even GraphQL error
  // messages can echo input. Only a known code may cross into cache or telemetry.
  const error: GraphQLRequestError = new Error(
    'Integration connection request failed.'
  );
  const code = graphQLErrorCode(cause);
  error.code =
    code && SAFE_ERROR_CODES.has(code) ? code : 'INTEGRATION_CONNECTION_FAILED';
  return error;
};

export const useIntegrationAuthFetcher = <TData, TVariables>(
  query: string
): ((variables: TVariables) => Promise<TData>) => {
  const fetcher = useFetcher<TData, TVariables>(query);
  return async (variables: TVariables): Promise<TData> => {
    try {
      return await fetcher(variables);
    } catch (error: unknown) {
      throw integrationAuthError(error);
    }
  };
};
